import React, { PureComponent } from 'react';

class PopularityDropdown extends PureComponent {

  onDropDownItemClick(e, activeItem){
    e.preventDefault();
    this.props.onDropDown(activeItem);
  }

  render(){
    const { activeDropDown } = this.props;

    return (
     <div className="options-menu-filters">
       <p className="subtitle">Filter By</p>
          <ul>
            <li onClick={e => this.onDropDownItemClick(e, 'Popularity') } ><a href="" className={`${activeDropDown === 'Popularity' ? 'active-filter' : ''}`}>Popularity</a></li>
            <li onClick={e => this.onDropDownItemClick(e, 'Lowest price') } ><a href="" className={`${activeDropDown === 'Lowest price' ? 'active-filter' : ''}`}>Lowest price</a></li>
            <li onClick={e => this.onDropDownItemClick(e, 'Highest price') } ><a href="" className={`${activeDropDown === 'Highest price' ? 'active-filter' : ''}`}>Highest price</a></li>
            <li onClick={e => this.onDropDownItemClick(e, 'Longest duration') } ><a href="" className={`${activeDropDown === 'Longest duration' ? 'active-filter' : ''}`}>Longest duration</a></li>
            <li onClick={e => this.onDropDownItemClick(e, 'Shortest duration') } ><a href="" className={`${activeDropDown === 'Shortest duration' ? 'active-filter' : ''}`}>Shortest duration</a></li>
          </ul>
      </div>
    )
  }

}

export default PopularityDropdown;



// WEBPACK FOOTER //
// ./src/components/tripSearch/filters/components/popularityDropdown.js